/* eslint-disable @next/next/no-img-element */
import { Button } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import Benefits from '@buddieshr/components/benefits';
import Features from '@buddieshr/components/app/features';
import Footer from '@buddieshr/components/footer';
import Header from '@buddieshr/components/header';
import MetaHeader from '@buddieshr/components/metaHeader';
import NonProfit from '@buddieshr/components/nonprofit';
import ReadyForBilly from '@buddieshr/components/billy/readyForBilly';
import styles from '@buddieshr/styles/Home_Billy.module.scss';
import AddToSlackButton from '@buddieshr/components/addToSlackButton';
import { PRODUCTS } from '@buddieshr/utils/constants-products';
import LovePanel from '@buddieshr/components/landing/lovePanel';

export default function FreeBirthdayBotSlack(pageProps) {
  const router = useRouter();
  const { t } = useTranslation();
  const app = PRODUCTS.find((c) => c.id === 'Billy');

  return (
    <>
      <MetaHeader
        title={t('metaTitleFreeBDBot')}
        description={t('metaDescriptionFreeBDBot')}
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/${app.urlSlug || app.slug}/free-birthday-bot-slack`}
        pageSlug={`${app.urlSlug || app.slug}/free-birthday-bot-slack`}
        locale={router.locale}
      />
      <div className={styles.container}>
        <Header app={app} />
        <main style={{ background: app.backgroundColor }}>
          <div>
            <div className={styles.FreeBDBot_inner}>
              {/* Header */}
              <div className={styles.Page_header_wrapper}>
                <h1
                  className={styles.bold}
                  style={{
                    width: '900px',
                    maxWidth: '100%',
                    margin: 'auto',
                  }}
                >
                  {t('titleFreeBDBot')}
                </h1>
                <div className={styles.Page_header_description}>
                  {t('descriptionFreeBDBot')}
                </div>
                <AddToSlackButton
                  app={app}
                  id="CTA_FreeBDBot"
                  style={{ margin: 'auto', marginTop: '12px' }}
                />
                <div className={styles.CTA_hint}>
                 Free under 10 employees • 30-day Free trial • Cancel anytime
                </div>
              </div>
              <div>
                <LovePanel showStars filterKeyword="billy" />
              </div>
              <Benefits app={app} />
              <Features app={app} />
              <div style={{ textAlign: 'center', marginBottom: 120 }}>
                <AddToSlackButton text="Install Billy for Free" app={app} />
              </div>
              <ReadyForBilly app={app} />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          </div>
        </main>
        <Footer app={app} />
      </div>
    </>
  );
}
